import { TextField as AriaTextField, type TextFieldProps as AriaTextFieldProps, composeRenderProps, type TextAreaProps } from 'react-aria-components';
import { cn } from '../../../components/utils';
import type { BaseFieldProps } from '../../../components/types';
import { FieldLabelWithHtml } from '../base-controls/FieldLabelWithHtml';
import { FieldDescription } from '../base-controls/FieldDescription';
import { FieldError } from '../base-controls/FieldError';
import { TextArea } from '../base-controls/text-controls/TextArea';
import { baseControlStyles } from '../base-controls/util';

export interface TextAreaFieldProps extends AriaTextFieldProps, BaseFieldProps {
	inputProps?: TextAreaProps;
}

export function TextAreaField({ label, description, inputProps, ...props }: TextAreaFieldProps) {
	const { base } = baseControlStyles();
	return (
		<AriaTextField
			{...props}
			className={composeRenderProps(props.className, className => cn(base(), className))}
			aria-label={label}
			isRequired={props.required}
		>
			{!props.hideLabel ? <FieldLabelWithHtml className="mb-1" label={label} required={props.required ?? false} /> : null}
			<TextArea {...inputProps} />
			<FieldDescription>{description}</FieldDescription>
			{props.error && <FieldError {...props.error} />}
		</AriaTextField>
	);
}
